import { Link } from 'react-router-dom';

const LOGO_LIGHT = 'https://downsconstructionllc.com/assets/images/logo-light.png';

const serviceLinks = [
  { label: 'Interior & Exterior Renovations', href: '/services/renovations' },
  { label: 'Pole Barns', href: '/services/pole-barns' },
  { label: 'Home Additions', href: '/services/additions' },
  { label: 'General Contracting', href: '/services/general-contracting' },
];

export default function FooterSection() {
  return (
    <footer className="bg-primary-dark pt-14 pb-0">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 border-b border-white/10">
          {/* Logo + tagline */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" aria-label="Home">
              <img src={LOGO_LIGHT} alt="Downs Construction LLC" className="h-14 w-auto mb-4" loading="lazy" decoding="async" />
            </Link>
            <p className="text-blue-200/60 text-sm leading-relaxed mb-6">
              Michigan&apos;s trusted construction experts since 1992. Serving Battle Creek and Southwest Michigan.
            </p>
            <div className="flex gap-3">
              <a href="https://facebook.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-primary-mid text-blue-300/60 hover:text-white rounded-md transition-all duration-200 cursor-pointer btn-press">
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a href="https://instagram.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-primary-mid text-blue-300/60 hover:text-white rounded-md transition-all duration-200 cursor-pointer btn-press">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="https://google.com" rel="nofollow" target="_blank" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-primary-mid text-blue-300/60 hover:text-white rounded-md transition-all duration-200 cursor-pointer btn-press">
                <i className="ri-google-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Information */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-5 flex items-center gap-2">
              <span className="w-4 h-0.5 bg-primary-mid inline-block"></span>
              Information
            </h4>
            <ul className="flex flex-col gap-3">
              <li><Link to="/" className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer link-underline link-underline-light">Home</Link></li>
              <li><Link to="/about" className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer link-underline link-underline-light">About Us</Link></li>
              <li><Link to="/contact" className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer link-underline link-underline-light">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-5 flex items-center gap-2">
              <span className="w-4 h-0.5 bg-primary-mid inline-block"></span>
              Services
            </h4>
            <ul className="flex flex-col gap-3">
              {serviceLinks.map((s) => (
                <li key={s.label}>
                  <Link to={s.href} className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer link-underline link-underline-light">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-[0.2em] mb-5 flex items-center gap-2">
              <span className="w-4 h-0.5 bg-primary-mid inline-block"></span>
              Contact
            </h4>
            <ul className="flex flex-col gap-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-primary-light text-sm"></i>
                </div>
                <span className="text-blue-200/60 text-sm">Battle Creek, MI</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-primary-light text-sm"></i>
                </div>
                <a href="tel:269-599-4913" className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer">(269) 599-4913</a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-primary-light text-sm"></i>
                </div>
                <a href="mailto:downsconstructionllc@gmail.com" className="text-blue-200/60 hover:text-white text-sm transition-colors duration-200 cursor-pointer break-all">
                  downsconstructionllc@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span className="text-blue-200/40 text-xs">Copyright 2026 - Present &mdash; Downs Construction LLC</span>
          <span className="text-blue-200/40 text-xs">
            Designed by{' '}
            <a
              href="https://kalamazoowebsitedesign.com"
              target="_blank"
              rel="nofollow"
              className="text-blue-200/60 hover:text-white transition-colors duration-200 underline underline-offset-2"
            >
              Kalamazoo Website Design
            </a>
            {' '}&mdash; All Rights Reserved
          </span>
        </div>
      </div>
    </footer>
  );
}
